import {getPaddedNumber} from '../../components/timestamp-field/PadNumber';
import {Injectable} from '@angular/core';

@Injectable()
export class DateFieldService {

  /**
   * Parses a date object from the string date given from the server
   * @param {string} dateString the date to parse in format of YYYY-MM-DD
   * @returns {Date}
   */
  parseDate(dateString: string) {
    const parts = dateString.split('-');
    //              month       /   day          /  year
    return new Date(parts[1] + '/' + parts[2] + '/' + parts[0]);
  }

  /**
   * Gets the data format that should be saved on the server
   * @param {Date} date
   * @returns {string}
   */
  getServerDateString(date: Date) {
    return date.getFullYear() + '-' + getPaddedNumber((date.getMonth() + 1)) + '-' + getPaddedNumber(date.getDate());
  }

  /**
   * Display the date in the local format
   * @param {string} dateString The string from the server
   * @returns {any}
   */
  getDateValue(dateString: string) {
    if (dateString === '' || dateString == null)
      return '';
    const date = this.parseDate(dateString);
    return date.toLocaleDateString();
  }
  /**
   *
   * @param dateValue
   * @returns {Date}
   */
  public parseServerDate(dateValue) {
    if (dateValue)
      return  this.parseDate(dateValue);
    return null;
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/services/date-field/date-field.service.ts